import { doc, setDoc } from 'firebase/firestore';
import { JobType } from "@leedpulse-monorepo/enums";
import { firestore } from '../../../firebase.config';
import { generateCustomDocId, calculateFutureTimestampForJob } from '@leedpulse-monorepo/utils'

interface CreateJobParams {
  idApiKey: string;
  idContact: string;
  type: JobType;
  timestamp?: number | null;
}

const createJob = async (params: CreateJobParams) => {
  const db = firestore;
  const customID = generateCustomDocId() + '-job';

  const { idApiKey, idContact, type, timestamp } = params;

  try {
    const jobRef = doc(db, 'Jobs', customID);

    await setDoc(jobRef, {
      id: customID,
      id_api_key: idApiKey,
      id_contact: idContact,
      type,
      timestamp: timestamp || calculateFutureTimestampForJob(type),
      timestamp_lock: 0,
      rescheduled: false,
      created: new Date().getTime(),
      updated: new Date().getTime(),
      attempts: 0,
      last_error: null,
      workflow: null,
    });

    return jobRef.id;
  } catch (e) {
    console.error('Error adding document with custom ID:', e);
    throw e;
  }
};

export default createJob;
